import { render, staticRenderFns } from "./SnakBar.vue?vue&type=template&id=2d4b78a9&scoped=true&"
import script from "./SnakBar.vue?vue&type=script&lang=js&"
export * from "./SnakBar.vue?vue&type=script&lang=js&"
import style0 from "./SnakBar.vue?vue&type=style&index=0&id=2d4b78a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b78a9",
  null
  
)

export default component.exports